import React from 'react';
import { Col, Row, Form, Input, AutoComplete } from 'antd';
import { PhoneNumberAutoComplete } from '../../../../components/phone-input';
import { formatPhoneNumber } from '../../../../helpers/formatPhoneNumber';
import { useSelector } from 'react-redux';
import { debounce } from '../../../../helpers/debounce';

const OwnerFieldsRow = ({ form }) => {
  const { ownerName, ownerPhone, ownerInfo, applicants } = useSelector(
    (state) => ({
      ownerName: state.newRequestStore.ownerName,
      ownerPhone: state.newRequestStore.ownerPhone,
      ownerInfo: state.newRequestStore.ownerInfo,
      applicants: state.newRequestStore.applicants,
    })
  );

  const handleOwnerPhoneChange = (value) => {
    if (value.length === 10) {
      const applicant = applicants.find((item) => {
        const phone = formatPhoneNumber({ phoneNumber: item.phone });
        return value === phone;
      });

      if (applicant) {
        form.setFieldsValue({ name: applicant.fio || applicant.name || '' });
      }
    }
  };

  const debouncedApplicantAutocomplete = debounce((value) => {
    const applicant = applicants.find(
      (applicant) => String(applicant.id) === value || applicant.name === value
    );

    if (applicant) {
      form.setFieldsValue({ phone_number: applicant.phone || '' });
    }
  }, 700);

  const handleOwnerNameChange = (value) => {
    debouncedApplicantAutocomplete(value);
  };

  return (
    <Row gutter={16}>
      <Col span={9}>
        <Form.Item label="Телефон">
          {form.getFieldDecorator('phone_number', {
            initialValue: ownerPhone || '',
            rules: [
              {
                required: ownerInfo,
                message: 'Пожалуйста введите Номер телефона',
              },
              { len: 10, message: '10 цифр' },
            ],
          })(
            <PhoneNumberAutoComplete
              inputProps={{ addonBefore: '+7' }}
              applicants={applicants}
              onChange={handleOwnerPhoneChange}
            />
          )}
        </Form.Item>
      </Col>
      <Col span={15}>
        <Form.Item label="Ф.И.О.">
          {form.getFieldDecorator('name', {
            initialValue: ownerName,
          })(
            <AutoComplete
              getPopupContainer={(trigger) => trigger.parentElement}
              onChange={handleOwnerNameChange}
              dataSource={applicants
                .filter((applicant) => applicant.name || applicant.fio)
                .map((applicant) => ({
                  value: applicant.id || '',
                  text: applicant.fio || applicant.name || '',
                }))}
              placeholder="ф.и.о."
            >
              <Input />
            </AutoComplete>
          )}
        </Form.Item>
      </Col>
    </Row>
  );
};

export default OwnerFieldsRow;
